
import * as Sentry from "@sentry/react";
import { supabase } from "@/integrations/supabase/client";

export const initSentry = async () => {
  try {
    // Fetch Sentry DSN from Supabase edge function
    const { data, error } = await supabase.functions.invoke('get-sentry-config');
    
    if (error || !data?.dsn) {
      console.warn('Failed to fetch Sentry configuration:', error);
      return;
    }

    Sentry.init({
      dsn: data.dsn,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
        }),
      ],
      // Performance Monitoring
      tracesSampleRate: 1.0, // Capture 100% of the transactions
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
  } catch (error) {
    console.warn('Failed to initialize Sentry:', error);
  }
};

// Error boundary component using Sentry
export const SentryErrorBoundary = Sentry.withErrorBoundary;
